
<template>
    <div>
        <h3 class="text-uppercase text-center" v-if="! isLoadingBlade">
            {{ isEdit }} ACCREDITED {{ type }} School 
        </h3>
        <hr v-if="! isLoadingBlade">
        <div class="row align-items-center" v-if="! isLoadingBlade">

            <div class="col-lg-6">
                <base-input alternative=""
                    label="School's Name"
                    required
                >
                    <autocomplete
                        ref="schoolAutocomplete"
                        input-class="form-control form-control-alternative"
                        placeholder="Type to search School"
                        showNoResults
                        :disableInput="all_schools && all_schools.length == 0"
                        :source="all_schools"
                        resultsValue="name"
                        :results-display="formattedDisplay"
                        :initialDisplay="record.name"
                        @selected="updateSchoolName"
                    >
                    </autocomplete>
                </base-input>
            </div>

            <div class="col-lg-6">
                <base-input alternative=""
                    label="Approved Quota"
                    placeholder="Enter Approved Quota"
                    input-classes="form-control-alternative"
                    v-model="record.quota"
                    type="number"
                    required
                />
            </div>

            <div class="col-lg-6">
                <base-input alternative=""
                    label="Accreditation Type"
                    required
                >
                    <select
                        class="form-control form-control-alternative"
                        v-model="record.accredit_status"
                    >
                        <option :value="null" disabled selected>--- Select One ---</option>
                        <option value="full-accreditation">Full Accreditation</option>
                        <option value="partial-accreditation">Partial Accreditation</option>
                    </select>
                </base-input>
            </div>

            <div class="col-lg-6">
                <base-input alternative=""
                    label="Institution Type"
                    required
                >
                    <select
                        class="form-control form-control-alternative"
                        v-model="record.type"
                        disabled
                    >
                        <option :value="null" disabled selected>--- Select One ---</option>
                        <option value="medical">Medical School</option>
                        <option value="dental">Dental School</option>
                    </select>
                </base-input>
            </div>

            <div
                class="col-sm-12 text-center"
                v-if='showErrorStatus'
            >
                <base-alert :type="errorType">
                    <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                    <span class="alert-inner--text">
                        {{errorMsg}}
                    </span>
                </base-alert>
            </div>

            <hr class="my-4" />

            <div class="col-lg-12">
                <base-button
                    type="success" size="lg"
                    @click="updateSchool()"
                    :disabled="(privileges && privileges.add == 'no') || ! privileges"
                >
                    <i class="fa fa-save"></i>
                    {{isloading ? 'Please Wait...' : isEdit + ' Record'}}
                </base-button>

                <base-button
                    type="danger" size="lg"
                    class="right"
                    @click="$emit('addSchool')"
                >
                    <i class="fa fa-times"></i>
                    Cancel
                </base-button>
            </div>
        </div>

        <div class="col-lg-12" v-if="isLoadingBlade">
            <div class="d-flex justify-content-center">
                <img :src="loadingBladeUrl" />
            </div>
        </div>

    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex';
    import swal from 'sweetalert2';// import sweet alert
    import Autocomplete from 'vuejs-auto-complete';

    export default {
        name: 'AddAccreditedSchool',
        props: ['privileges', 'data', 'loadAccreditedSchools', 'type', 'all_schools'],
        components: {
            Autocomplete
        },
        data() {
            return {
                record: {
                    training_school_id: null,
                    name: null,
                    accredit_status: null,
                    quota: null,
                    type: this.type
                },
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isloading: false,
                isLoadingBlade: true
            }
        },
        computed: {
            ...mapGetters(['loadingBladeUrl']),
            isEdit() {
                return this.record && this.record.id ? 'Update' : 'Add';
            },
            disableType() {
                return this.record && this.record.id ? true : false;
            }
        },
        methods: {
            ...mapActions(['modifyDeleteSchool']),
            setData() {// set data for editing
                this.emptyRecords();
                let data = this.data;
                if(data) {
                    this.record =   {
                        training_school_id: data.training_school_id,
                        name: data.name,
                        accredit_status: data.accredit_status,
                        quota: data.quota,
                        type: data.type,
                        id: data.id
                    }
                }
                var self = this;
                setTimeout(function() { self.isLoadingBlade = false; }, 100);
            },
            emptyRecords() {
                return this.record = {
                    training_school_id: null,
                    name: null,
                    accredit_status: null,
                    quota: null,
                    type: this.type
                };
            },
            updateSchoolName(e) {// update school name
                this.record.training_school_id = null;
                this.record.name = null;
                this.record.training_school_id = e.value;
                this.record.name = e.display;
            },
            updateSchool() {
                let status = this.validatedInputs();// validate inputs
                if(status) {// save department
                    let data = this.record;
                    data.admin_id = this.$store.state.user.userId;// add admin user id
                    data.option = 'update';
                    this.preloader(); // show loading
                    this.modifyDeleteSchool(data).then((res) => {// update unit
                        this.loadAccreditedSchools();// refresh page
                        if(res.status) {
                            let type = (this.isEdit == 'Update') ? 'Updated' : 'Added';
                            swal.fire("Record "+type, res.msg, "success");
                        } else {
                            swal.fire("Error Occurred!", res.msg, "warning");
                        }
                    }).
                    catch(err => {
                        this.loadAccreditedSchools();// refresh page
                        swal.fire(err.message+"!", "An error occurred while processing, try again", "warning");
                    });
                }
            },
            validatedInputs() {
                let data = this.record;
                let school = { training_school_id: null, accredit_status: null, quota: null, type: null };
                school.type = data.type ? data.type : this.showInuptError('Institution Type');
                school.accredit_status = data.accredit_status ? data.accredit_status : this.showInuptError('Accreditation Type');
                school.quota = data.quota ? data.quota : this.showInuptError('Approved Quota');
                school.training_school_id = data.training_school_id 
                                ? data.training_school_id : this.showInuptError('School\'s Name');
                return this.isEmpty(school) ? true : false;
            },
            isEmpty(obj) {// check for empty field
                return ! Object.keys(obj).some(k => !obj[k]);
            },
            showInuptError(name) {
                this.isloading = false;
                this.showErrorStatus = true;
                this.errorType = 'warning'
                this.errorMsg = 'Invalid ' + name + ' has been entered';
                var self = this;
                setTimeout(function() { self.showErrorStatus = false; }, 5000);
            },
            formattedDisplay (result) {
                return result.school_name;
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        },
        mounted() {// set records
            this.setData();
        }
    };
</script>
<style scoped>
    .right {
        float: right;
    }
    .marginTop40 {
        margin-top: 40px;
    }
</style>

<style>
    .form-control-label {
        width: 100%;
    }
</style>